import axios from "axios";
import Decrypt2, { Encrypt } from "../Cryptography/CryptoJS";
import { csrfToken } from "./APIEndPoints";
import { getLocalCSRFToken } from "./APIToken";
import { deleteCookie, deleteLocalStorage } from "../Context/Context";
import { checkPermission } from "../PageAccess/CheckPermission";
import { toast } from "react-toastify";
import { getFromEncLocalStorage } from "../Utils/Utils";
import { decryptV2 } from "../Cryptography/CryptoV2";

let isSessionExpired = false;

export async function APICall(apiUrl, inputParameter, methodType = "POST") {
  try {
    let pathName = window.location.hash;

    console.log("pathName: ", pathName);

    const permissionName = checkPermission(pathName);

    const userId = getFromEncLocalStorage("userId");
    const userRoleValue = getFromEncLocalStorage("userRole");

    console.log("permissionName: ", permissionName);
    console.log("userId: ", userId);
    // Adding permission name and userId with each new request

    if (!inputParameter || typeof inputParameter != "object") {
      inputParameter = {};
    }

    if (inputParameter) {
      if (
        !inputParameter.userIdForSession ||
        inputParameter.userIdForSession == null
      ) {
        inputParameter.userIdForSession = userId;
        inputParameter.userLoggedInAsPermission = userRoleValue || "";
      }
      inputParameter.permissionName = permissionName;
    }

    let encryptedParams = await Encrypt(JSON.stringify(inputParameter));
    // let CSRFToken = apiUrl == csrfToken ? "" : await getLocalCSRFToken();

    let reqObj = {
      data: encryptedParams,
      // "x-csrf-token": CSRFToken
    };

    console.log(`reqObj: ${JSON.stringify(reqObj)}, apiUrl:${apiUrl}`);

    let response = await axios.request({
      withCredentials: true,
      method: methodType,
      url: apiUrl,
      //credentials: "include",
      data: reqObj,
      headers: {
        "Access-Control-Allow-Origin": "SAMEORIGIN",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        // "Access-Control-Allow-Origin": "SAMEORIGIN",
        // "Access-Control-Allow-Methods": "GET,PUT,POST",
        // "Access-Control-Allow-Headers": "SAMEORIGIN",
        // "Content-Type": "application/json",
        // "X-Frame-Options": "SAMEORIGIN",
        // "X-Powered-By": "Server",
        // "X-XSS-Protection": "1; mode=block",
        // "x-content-type": "nosniff",
        // "Strict-Transport-Security": "max-age=10368000",
        // "x-csrf-token": CSRFToken
      },
    });

    //if (typeof response.data.data === "string") {
    // let decryptedData = await Decrypt2(response.data.data);
    // return await JSON.parse(decryptedData);

    //return response.data;
    //} else {
    if (response.data.message === "INVALIDUSER" && !isSessionExpired) {
      if (window.isSessionExpiredShown) {
        return;
      }
      window.isSessionExpiredShown = true;
      if (confirm("Session expired, please login again")) {
        deleteCookie("ApplicationToken");
        deleteLocalStorage();
        isSessionExpired = true;
        window.location.href = `${window.location.origin}/login`;
        window.isSessionExpiredShown = false;
      }
    } else if (response.data.message === "Unauthorized" && !isSessionExpired) {
      if (window.isUnauthorizedShown) {
        return;
      }
      window.isUnauthorizedShown = true;
      if (confirm("Something went wrong, please login again")) {
        deleteCookie("ApplicationToken");
        deleteLocalStorage();
        isSessionExpired = true;
        window.location.href = `${window.location.origin}/login`;
        window.isUnauthorizedShown = false;
      }
    } else if (response.data.message === "Special characters not allowed") {
      toast("Special characters not allowed");
      isSessionExpired = false;
      return;
    } else if (response.data.message === "Duplicate entry for hashtag") {
      toast("Duplicate entry for hashtag");
      isSessionExpired = false;
      return;
    }

    let respData = response.data;
    if (typeof respData?.data === "string") {
      let decData = decryptV2(respData?.data);
      respData.data = JSON.parse(decData);
    }

    isSessionExpired = false

    return respData;
    //}
  } catch (error) {
    if (error.response.data.message === "Unauthorized") {
      if (confirm("Session expired, please login again")) {
        deleteCookie("ApplicationToken");
        isSessionExpired = true;
        window.location.href = `${window.location.origin}/login`;
      }
    }
    isSessionExpired = false;
    console.error(error, "error");
    return await error.response.data;
  }
}


export async function APICallFormDataPOST(apiUrl, formData) {
  let response = await axios.post(
    apiUrl,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
}